import React from "react";
import { Badge } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const FLAGGED = ["AG Flagged", "Audit Flagged"];

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

/**
 * The exception banner for a release (and for its PVs).
 *
 * A flag is a marker: it does not stop the release moving through the treasury
 * pipeline, so this has to be visible wherever the release is looked at rather
 * than only on the audit screen.
 */
const AuditFlagBanner = ({ auditStatus, exceptions = [], className = "" }) => {
  if (!FLAGGED.includes(auditStatus) || !exceptions.length) return null;

  const latest = exceptions[0];

  return (
    <div className={`alert alert-danger ${className}`.trim()} role="alert">
      <div className="d-flex align-items-start">
        <FontAwesomeIcon icon={faExclamationTriangle} className="me-2 mt-1" />
        <div className="flex-grow-1">
          <div className="fw-bold mb-1">
            {auditStatus === "AG Flagged"
              ? "Flagged by the Auditor General"
              : "Flagged by the release auditor"}
            {exceptions.length > 1 && (
              <Badge bg="dark" className="ms-2">
                {exceptions.length} exceptions
              </Badge>
            )}
          </div>
          <div>
            {latest.category && (
              <Badge bg="light" text="dark" className="me-2">
                {latest.category}
              </Badge>
            )}
            <span style={{ whiteSpace: "pre-wrap" }}>{latest.remark}</span>
          </div>
          <small className="d-block mt-1">
            {latest.commented_by || "Auditor"}
            {latest.created_at ? ` · ${formatDate(latest.created_at)}` : ""}
          </small>
        </div>
      </div>
    </div>
  );
};

export default AuditFlagBanner;
